import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { getScrollTop, unit2pixel, isElementHidden, getScrollParent } from '@/shared/util';
import { computed, reactive, watch, ref, onMounted, onBeforeUnmount } from 'vue';
var __default__ = {
    name: 'XSticky'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        zIndex: [
            Number,
            String
        ],
        position: {
            type: String,
            validator: function validator(value) {
                return [
                    'top',
                    'bottom'
                ].includes(value);
            },
            default: 'top'
        },
        container: Element,
        offsetTop: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        offsetBottom: {
            type: [
                Number,
                String
            ],
            default: 0
        }
    },
    emits: [
        "change",
        "scroll"
    ],
    setup: function setup(__props, param) {
        var emit = param.emit;
        var props = __props;
        /**
 * fork https://github.com/youzan/vant/blob/2.x/src/sticky/index.js
 */ var offsetPixel = computed(function() {
            return unit2pixel(props.position === 'top' ? props.offsetTop : props.offsetBottom);
        });
        var state = reactive({
            fixed: false,
            width: 0,
            height: 0,
            transform: 0
        });
        var rootStyle = computed(function() {
            if (state.fixed) {
                return {
                    width: "".concat(state.width, "px"),
                    height: "".concat(state.height, "px")
                };
            }
            return {};
        });
        var stickyStyle = computed(function() {
            if (!state.fixed) {
                return;
            }
            var style = _define_property({
                width: "".concat(state.width, "px"),
                height: "".concat(state.height, "px")
            }, props.position, "".concat(offsetPixel.value, "px"));
            if (state.transform) {
                style.transform = "translate3d(0, ".concat(state.transform, "px, 0)");
            }
            return style;
        });
        watch(function() {
            return state.fixed;
        }, function(value) {
            emit('change', value);
        });
        var root = ref(null);
        var onScroll = function onScroll() {
            if (!root.value || isElementHidden(root.value)) {
                return;
            }
            var container = props.container, position = props.position;
            var rootRect = root.value.getBoundingClientRect();
            var scrollTop = getScrollTop(window);
            state.width = rootRect.width;
            state.height = rootRect.height;
            if (position === 'top') {
                if (container) {
                    var containerRect = container.getBoundingClientRect();
                    var difference = containerRect.bottom - offsetPixel.value - state.height;
                    state.fixed = offsetPixel.value > rootRect.top && containerRect.bottom > 0;
                    state.transform = difference < 0 ? difference : 0;
                } else {
                    state.fixed = offsetPixel.value > rootRect.top;
                }
            } else {
                var clientHeight = document.documentElement.clientHeight;
                if (container) {
                    var containerRect1 = container.getBoundingClientRect();
                    var difference1 = clientHeight - containerRect1.top - offsetPixel.value - state.height;
                    state.fixed = clientHeight - offsetPixel.value < rootRect.bottom && clientHeight > containerRect1.top;
                    state.transform = difference1 < 0 ? -difference1 : 0;
                } else {
                    state.fixed = clientHeight - offsetPixel.value < rootRect.bottom;
                }
            }
            emit('scroll', {
                scrollTop: scrollTop,
                isFixed: state.fixed
            });
        };
        var scrollParent = ref();
        onMounted(function() {
            if (!scrollParent.value) {
                scrollParent.value = getScrollParent(root.value);
            }
            scrollParent.value.addEventListener('scroll', onScroll, {
                passive: false
            });
            onScroll();
        });
        onBeforeUnmount(function() {
            var _scrollParent_value;
            (_scrollParent_value = scrollParent.value) === null || _scrollParent_value === void 0 ? void 0 : _scrollParent_value.removeEventListener('scroll', onScroll);
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            offsetPixel: offsetPixel,
            state: state,
            rootStyle: rootStyle,
            stickyStyle: stickyStyle,
            root: root,
            onScroll: onScroll,
            scrollParent: scrollParent
        };
    }
}));
